import {
    ChangeDetectionStrategy,
    Component,
    computed,
    EventEmitter,
    Input,
    input,
    Output,
    ViewChild,
    ViewEncapsulation,
} from "@angular/core";
import { S25ButtonComponent } from "../../../standalone/s25.button.component";
import { S25ModalModule } from "../../s25-modal/s25.modal.module";
import { S25ModalComponent } from "../../s25-modal/s25.modal.component";

@Component({
    selector: "s25-ng-table-header-select-all",
    template: `
        <div>{{ label }}</div>
        <s25-ng-button [type]="'link'" (click)="onAction()">{{ action() }}</s25-ng-button>

        <s25-ng-modal #confirmSelectionModal [title]="'Confirm Selection'" [type]="'confirm'" [size]="'xxs'">
            Are you sure that you want to <em>{{ allSelected() ? "deselect" : "select" }} all</em> items in the
            <em>{{ label }}</em> column?
        </s25-ng-modal>
    `,
    styles: `
        :host {
            display: grid;
            justify-items: center;
            line-height: 1.1;
        }

        em {
            font-style: normal;
            font-weight: bold;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25ButtonComponent, S25ModalModule],
})
export class TableHeaderSelectAllComponent {
    @Input({ required: true }) label: string;
    // allSelected should be required, but it breaks tests
    allSelected = input<boolean>();
    action = computed(() => (this.allSelected() ? "Deselect All" : "Select All"));

    @Output() toggle = new EventEmitter<boolean>();

    @ViewChild("confirmSelectionModal") confirmSelectionModal: S25ModalComponent;

    async onAction() {
        const ok = await this.confirmSelectionModal.open();
        if (!ok) return;

        this.toggle.emit(!this.allSelected());
    }
}
